import React, { Component } from "react";
import { withRouter } from "react-router";

import {
  FormGroup,
  Row,
  Col,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormFeedback,
} from "reactstrap";
import { nameSchema } from "../../utils/validateForm";
import Picker from 'emoji-picker-react';
import api from "../../utils/axiosApi";
import withReactContent from "sweetalert2-react-content";
import { Toast } from "../../utils/sweetalert";

class FormCityEdit extends Component {
  constructor(props) {
    super(props) 
    const {cityData} = props
    const city = cityData.city,
      state = cityData.state,
      country = cityData.country,
      cityEn = cityData.cityEn,
      stateEn = cityData.stateEn,
      countryEn = cityData.countryEn,
      priceTypeDefault = cityData.priceTypeDefault,
      lat = cityData.lat,
      lon = cityData.lon,
      latAirport=cityData.airportCoord?.lat,
      lonAirport=cityData.airportCoord?.lon,
      radius = cityData.radius,
      emoji= cityData.emoji,
      priority= cityData.priority
    this.state = {
      city : city ||'',
      state : state || '',
      country : country || '',
      cityEn : cityEn || '',
      stateEn : stateEn || '',
      countryEn : countryEn || '',
      priority : priority || 0,
      priceTypeDefault : priceTypeDefault || '$',
      lat: lat||0,
      lon:lon || 0,
      latAirport: latAirport || 0,
      lonAirport: lonAirport ||0,
      radius: radius || 1500,
      disabled:false,
      emoji:emoji || undefined,
      citiesList:[],
      errors : {
        city : false,
        state : false,
        country : false,
        citiesList:false
      }
    }
  }
  handleChange = (e) => {
    debugger
    const value = e.target.value
    this.setState({[e.target.name]: value})
  }
  
  handleChangeLngLat = (e) => {
    debugger
    const amount = e.target.value !== '' ? e.target.value.replace(',','.') : '0'
    if (!amount || amount.match(/^-?\d{1,}(\.\d{0,})?$/)) {/*-----   /^\d{1,}(\.\d{0,4})?$/      -----------   ^-?\d{1,}(\.\d{0,4})?$   ---- */
      this.setState({[e.target.name]: (amount) });
    }

  }
  
  handleLonLat = (lonLat) => {
    this.setState({lon: lonLat.lng, lat: lonLat.lat}) //{lon: lonLat.lng, lat: lonLat.lat}
  }
  handleSubmit = async (e) =>{
    e.preventDefault()
    const cityValidation = nameSchema.validate(this.state.city);
        const stateValidation = nameSchema.validate(this.state.state);
        const countryValidation = nameSchema.validate(this.state.country)
        let newStateError = {
            city : false,
            state : false,
            country : false,
            citiesList:false
          }
        if (cityValidation.error) {
            
            newStateError = {...newStateError, city: true}
        }
        if (stateValidation.error) {
            
            newStateError = {...newStateError, state: true}
        }
        if (countryValidation.error) {
            newStateError = {...newStateError, country: true}
        }
        this.setState({errors: newStateError})
        if(cityValidation.error || stateValidation.error || countryValidation.error) {return}
        //edit
        const data = {
          
          _id:this.props.cityData._id,
          
          city : this.state.city,
          state : this.state.state,
          country : this.state.country,
          fullName : `${this.state.city}, ${this.state.state}, ${this.state.country}`.toLowerCase(),
          cityEn : this.state.cityEn,
          stateEn : this.state.stateEn,
          countryEn : this.state.countryEn,
          fullNameEn : `${this.state.cityEn}, ${this.state.stateEn}, ${this.state.countryEn}`.toLowerCase(),
          priceTypeDefault : this.state.priceTypeDefault,
          lat : parseFloat(this.state.lat),
          lon : parseFloat(this.state.lon),
          airportCoord:{
            lat : parseFloat(this.state.latAirport || this.state.lat),
            lon : parseFloat(this.state.lonAirport || this.state.lon),
          },
          radius : parseFloat(this.state.radius),
          priority : parseFloat(this.state.priority),
          emoji: this.state.emoji
        }
        const MySwal = withReactContent(Toast)
        try {
          await api.put(`/ciudades/editcity`, data)
          await MySwal.fire({
              title: <p style={{fontSize: '15px'}}>Ciudad editada Exitosamente</p>,
              icon: 'success',
              
          })
          this.props.onClose?.()
        } catch (error) {
          await MySwal.fire({
            title: <p style={{fontSize: '15px'}}>No se pudo editar</p>,
            icon: 'error',
            
        })
        }

  }
  handleDeleteCity =(index) =>{
    const cities = [...this.state.citiesList]
    cities.splice(index, 1)
    this.setState({citiesList: cities})
  }
  logEmoji (event, emojiObject) {
    this.setState({emoji: {
      emoji: emojiObject.emoji,
      url: `https://cdn.jsdelivr.net/npm/emoji-datasource-apple@6.0.1/img/apple/64/${emojiObject.unified}.png`
    }})
  }
  render() {
    return (
      <>
      <div className="content">
        <Row>
          <Col md="12">
          <Card>
          <CardHeader>
          <Row>
            <Col>
          <CardTitle tag="h4">Editar ciudad</CardTitle></Col>
            <Col className="d-flex justify-content-center align-items-center"><Button onClick={this.props.onClose} disabled={this.state.disabled} color="danger" type="button">
            Volver
          </Button></Col>
          </Row>
          </CardHeader>
      <CardBody>
        <form onSubmit={this.handleSubmit}>
        <Row className='m-0'>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="city">ciudad</Label>
                    <Input
                        id="city"
                        name="city"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.city}
                        invalid={this.state.errors.city}
                        placeholder="ciudad"
                    />
                    <FormFeedback>El campo ciudad esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="state">Estado</Label>
                    <Input
                        id="state"
                        name="state"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.state}
                        invalid={this.state.errors.state}
                        placeholder="Estado"
                    />
                    <FormFeedback>El campo estado esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="country">Pais</Label>
                    <Input 
                    className='p-0'
                      value={this.state.country} 
                        name="country"
                        id="country"
                        invalid={this.state.errors.country}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                    <FormFeedback>El Campo Pais esta vacio</FormFeedback>
                </FormGroup>
            </Col>
            {/**lo mismo pero en ingles */}
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="cityEn">city</Label>
                    <Input
                        id="cityEn"
                        name="cityEn"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.cityEn}
                        invalid={this.state.errors.city}
                        placeholder="ciudad"
                    />
                    <FormFeedback>El campo ciudad esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="stateEn">State</Label>
                    <Input
                        id="stateEn"
                        name="stateEn"
                        onChange={this.handleChange}
                        type='text'
                        value={this.state.stateEn}
                        invalid={this.state.errors.state}
                        placeholder="Estado"
                    />
                    <FormFeedback>El campo estado esta Vacio</FormFeedback>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="4">
                <FormGroup>
                    <Label for="countryEn">Country</Label>
                    <Input 
                    className='p-0'
                      value={this.state.countryEn} 
                        name="countryEn"
                        id="countryEn"
                        invalid={this.state.errors.country}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                    <FormFeedback>El Campo Pais esta vacio</FormFeedback>
                </FormGroup>
            </Col>
        </Row>
        <Row className='m-0'>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="lat">lat</Label>
                    <Input
                        id="lat"
                        name="lat"
                        onChange={this.handleChangeLngLat}
                        type='text'
                        value={this.state.lat}
                        invalid={this.state.errors.lat}
                        placeholder="ciudad"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="lon">lon</Label>
                    <Input
                        id="lon"
                        name="lon"
                        onChange={this.handleChangeLngLat}
                        type='text'
                        value={this.state.lon}
                        invalid={this.state.errors.lon}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="radius">radio en metros</Label>
                    <Input 
                    className='p-0'
                      value={this.state.radius} 
                        name="radius"
                        id="radius"
                        invalid={this.state.errors.radius}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="3">
                <FormGroup>
                    <Label for="priceTypeDefault">Moneda default</Label>
                    <Input 
                    className='p-0'
                      value={this.state.priceTypeDefault} 
                        name="priceTypeDefault"
                        id="priceTypeDefault"
                        invalid={this.state.errors.priceTypeDefault}
                        onChange={this.handleChange}
                        type='text'>
                    {/*country.countries.map((c,i) => {
                        return <option key={`countries-${i}`} value={c.name}>{`${c.name}`}</option>
                    })*/}</Input>
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="latAirport">lat del aeropuerto</Label>
                    <Input
                        id="latAirport"
                        name="latAirport"
                        onChange={this.handleChangeLngLat}
                        type='text'
                        value={this.state.latAirport}
                        invalid={this.state.errors.latAirport}
                        placeholder="ciudad"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="lonAirport">lon del aeropuerto</Label>
                    <Input
                        id="lonAirport"
                        name="lonAirport"
                        onChange={this.handleChangeLngLat}
                        type='text'
                        value={this.state.lonAirport}
                        invalid={this.state.errors.lonAirport}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
            <Col className="pr-md-1" md="6">
                <FormGroup>
                    <Label for="priority">Prioridad</Label>
                    <Input
                        id="priority"
                        name="priority"
                        onChange={this.handleChangeLngLat}
                        type='number'
                        value={this.state.priority}
                        invalid={this.state.errors.priority}
                        placeholder="Estado"
                    />
                </FormGroup>
            </Col>
        </Row>

        <FormGroup>
                    <Label for="icon">Icon</Label>
                    <div className='iconPickerCont d-flex justify-content-around'>
                    <Picker 
                    onEmojiClick={this.logEmoji.bind(this)}
                    disableSkinTonePicker={true}
                    groupVisibility={false}
                    disableAutoFocus={true}
                    groupNames={{ smileys_people: "PEOPLE" }} />
                    <span>{this.state.emoji && <img alt={this.state.emoji.emoji} 
                    src={this.state.emoji.url}></img>}</span>
                    </div>
                </FormGroup>
          
          <Button color="primary" type="submit">
            Editar
          </Button>
        </form>
      </CardBody>
    </Card>
          </Col>
            
        </Row>
      </div>
    </>
    )
  }
}


export default withRouter(FormCityEdit);
